

export default {
  name: 'PngToJpg',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
          "@type": "Question",
          "name": "Does changing PNG to JPG files reduce quality?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "When converting from PNG to JPG online by JPG converter, you must accept that the image quality will decrease. The compression process will remove some unnecessary information from the image. You will get a JPG file that is significantly smaller than PNG files."
          }
      },{
          "@type": "Question",
          "name": "Does the JPG-convert-PNG tool do anything?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Increasing image quality is the most significant advantage that JPG-convert-PNG technology brings. PNG files are a lossless image format. So when saving images in this format, as long as you have the correct bit depth and color levels, you will get the image file with the highest resolution and quality."
          }
      },{
          "@type": "Question",
          "name": "Can PNG raster images be converted to JPG files?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Many tools support converting PNG images to JPG files. Most of the photo editing software available on the device support this feature. If you have a need to batch convert but do not affect jpg convert png image quality, free online tools will also help."
          }
      },{
          "@type": "Question",
          "name": "Is PNG smaller than JPEG?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "Most JPEG images are smaller in size than PNG files. The JPEG file format uses lossless DCT compression instead of DEFLATE compression like PNG."
          }
      },{
          "@type": "Question",
          "name": "How do I reduce the file size of a PNG?",
          "acceptedAnswer": {
              "@type": "Answer",
              "text": "You can use a compression, scaler, or JPG converter tool to shrink PNG. You can also make the image smaller by saving it in a different format, keeping it without using the alpha channel."
          }
      }]
    };
  },
  data() {
    return {
        filesSelected: 0,
        local_image: null,
        progress: 0,
        loading: false,
        isActive: false,
        form: this.$vform({ })
    };
  },
  methods: {
    onConvertType: function() {
      this.isActive = !this.isActive;
    },
    handleFileChange(event) {
        this.progress      = 0;
        this.filesSelected = event.target.files.length;
        this.local_image   = event.target.files[0];
    },
    onPngToJpg() {

        this.progress = 0;

        const config = {
          onUploadProgress: (progressEvent) => this.progress = Math.round((progressEvent.loaded * 100) / progressEvent.total)
        };

        const data = new FormData();

        data.append('local_image', this.local_image);

        this.loading = true;

        this.$axios.post(`/tool/png-to-jpg`, data, config, { headers: { 'Content-Type': 'multipart/form-data', 'Accept': 'multipart/form-data' } }).then(res => {
           
            jQuery('.download-image').attr( 'href',  res.data.download );

            jQuery('.preview-download-image').attr('src', res.data.preview);

            jQuery('#modalPreviewDownloadImage').modal('show');

        }).catch(e => {

          this.form.errors.set(e.response.data.errors);

        }).finally(() => {

          this.loading = false

       });
    }
  }
}
